<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  // mounted(){
  //   //刷新页面时也会执行
  //   window.addEventListener('beforeunload',()=>{
  //     localStorage.clear();
  //   });
  // }
}


</script>




// WEBPACK FOOTER //
// src/App.vue